<template>
	<div class="course-detail-padding width-800"> 
		<div class="print-position">
				<button class="print-button print-color button" @click="downloadCatalog()"> <img class="img-font-size mr-2 mb-1" id="" src="../../../assets/images/u224.svg"/> Download  </button>
		</div>
	
		<div class="detail-wrapper">
			
			<!-- <span class="bold-title row mb-2 pointer"  @click="collapseAll"> {{course_data.name}} -->
				<button class="print-button print-color button" @click="collapseAll"> {{program_detail_open_close}}  </button>
				<!-- <button class="print-button print-color button" @click="downloadCatalog()"> <img class="img-font-size mr-2 mb-1" id="" src="../../../assets/images/u224.svg"/> Download  </button> -->
				<span class="bold-title row mb-2 pointer"  @click="collapseAll">
				 <!-- <div class="ml-2"> -->
					<!-- <img :class="{'transform-180': allOpen}" class="img-font-size mt-2  		float-right" id="" src="../../../assets/images/keyboard_arrow_down_u50.svg"/>
					
					</div>  -->
				
			</span>
<!-- 
			<span class="normal-title row time-section mt-2 mb-2"> <img class="img-font-size mr-2" id="" src="../../../assets/images/access_time_u27.svg"/> {{secondsToHms(course_data.duration,false)}}</span>

			<span class="normal-title description-section row mt-2 mb-3"> {{course_data.description}} </span> -->
			<div id="accordion" class="accordion-container">
			<div class="row " v-for="(module, index) in course_data.modules" :key="index" :class="[
				'accordion',
				{ 'is-open': isOpen.includes(index) }
			]">
				<div class="course-wrapper" :class="{'gray-background' : isOpen.includes(index)}">
					<div  role="tablist">
						<a class="pointer"  @click="collapseModule(index)" >
						<div class="display-flex-row font-16">
							
							<div class="normal-title font-size-18 area-title" v-if="module.name != null" :class="{'blue-title-program-detail' : isOpen.includes(index)}" > {{module.name['EN'] || module.title}}

							</div>

							<div class=" area-duration">
								<img class="img-font-size mb-1 margin-right-6" id="" src="../../../assets/images/access_time_u27.svg"/> {{secondsToHms(module.duration,true)}}
							</div>

							<div class="area-language">
									<img class="mb-1 margin-right-6" id="" src="../../../assets/images/language_u50.svg" width="18"
								/> {{module.languages.length}}
							</div>

							<div class="section-quiz">
								 <img  v-if="module.has_quiz" class="mb-1" id="" src="../../../assets/images/quiz_icon.png" width="18"
								/>
								<div v-else>-</div>
							</div>

							<div>
							<img :class="{'transform-180': isOpen.includes(index)}" class="img-font-size mt-1 float-right" id="" src="../../../assets/images/keyboard_arrow_down_u50.svg"/>
							</div>
						</div>
							</a>

					</div>

				</div>
				<div class="module-detail accordion-body accordion-content display-flex">
					<div class="holder-language">
						Languages: 

						<div class="" v-for="(lang,index) in module.languages" :key="index">
									<p class="ml-2"> {{lang}} </p>
						</div>
					</div>

		
					<div class="holder-img">
							<img class="image-border holder-img" :src="module.image" />
							<div>
								{{module.description == null ? '' : module.description['EN']}}
							</div>
					</div>

					<div class="holder-lessons">
						Lessons:

						<div class="lesson-list">
							<div >
								<ol>
									<li class="min-height-100 lesson-title-font mb-3" v-for="(lesson,index) in module.lessons" :key="index">{{lesson.name['EN']}}  ({{secondsToHms(lesson.duration_int, false)}})
										<div  v-if="lesson.description" class="ml-1 mt-1 small-lesson-description">
											<div v-for="(txt,index) in descriptionSeperator(lesson.description['EN'])" :key='index'>
												- {{txt}}
											</div>
											
										</div>
										<div  class="ml-1 mt-1 small-lesson-description" v-else>
												-
										</div>



									</li>
							</ol>
							</div>
							
						</div>
					</div>
					
				</div>
			</div>
			</div>
		</div>
	</div>
</template>
<script >
import MixinSME from '../../sme/MixinSME';
export default {
	props:{
		course_data:{
			required: true
		}
	},
	mixins: [MixinSME],
	data: function(){
		return{
			id: this.$route.params.id,
			download_token: this.$store.getters.getDownloadToken,
			isOpen:[],
			allOpen:false,
			program_detail_open_close: 'Expand'
		}
	},
	computed : {
		user_view(){
			return this.$store.getters.getRole
		}
	},
	methods : {
		collapseModule: function(index){

			if (this.isOpen.includes(index)) {
				this.isOpen = this.isOpen.filter(i => i !== index);
				return;
			}

			this.isOpen.push(index);
			
		},
		collapseAll(){
			if(this.isOpen.length == 0){
				this.program_detail_open_close = 'Collapse'
				this.allOpen = true
				this.course_data.modules.forEach((elem, index) =>{
					this.isOpen.push(index)
				})
			}else{
				this.program_detail_open_close = 'Expand'
				this.isOpen = []
				this.allOpen = false
			}
		},
		descriptionSeperator(text){
			if(text != null){
				return text.split(';')
			}else{
				return ''
			}
		},
		downloadCatalog: function(){
			// var params = {
			// 	id: this.id,
			// 	filters : {
			// 		download_token: this.download_token
			// 	}
			// }
			var url = this.config.DOWNLOAD_PROGRAM_CATALOG.replace('%COURSE_ID%', this.id);
			url = url + '?download_token='+this.download_token;

			if(this.$store.getters.getRole == 'csm'){
				// params.filters.organization_id = this.$route.params.agency_id
				url = url + '&organization_id='+this.$route.params.agency_id
				window.open(url, '_self');

			}else{
				window.open(url, '_self');
			}
			// this.$store.dispatch('downloadCatalog', params).then((res) =>{
			// })
		}
	}

}
</script>
<style scoped src="./organizationcourse.css">
</style>



// WEBPACK FOOTER //
// src/components/organizations/courses/OrganizationCourseModuleDetail.vue